export default "__VITE_ASSET__C2_Z8lzp__"